module.exports = __webpack_public_path__ + "static/img/game-logo-sv388.29b2284.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-sv388.png
// module id = 0W29
// module chunks = 0 1 2 3 4 5 6